module.exports = {
  ConfigureDisplayColumns: 'กำหนดคอลัมน์ที่แสดง',
  AllNames: 'ชื่อทั้งหมด',
  SelectedColumns: 'คอลัมน์ที่เลือกแล้ว',
  YouToViewSecondaryInformation: 'คุณไม่มีสิทธิ์ดูข้อมูลตารางระดับสอง!',
  Yes: 'ใช่',
  WorkflowNumber: 'หมายเลขงาน',
  YouToSetSecondaryColumns: 'คุณไม่มีสิทธิ์ตั้งค่าคอลัมน์ที่แสดงในตารางระดับสอง!',
  CancelCounting: 'ยกเลิกนับจำนวน'
}
